<template>
  <v-select
    v-model="inputValue"
    v-bind="$attrs"
    @change="handleChange"
    item-value="value"
    item-text="text"
  />
</template>

<script>
export default {
  props: {
    value: null,
  },
  data() {
    return {
      inputValue: this.value ?? null,
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.inputValue = value;
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', this.inputValue);
    },
  },
};
</script>
